<script>
    import get from 'lodash/get';

    export default {
        data() {
            return {
                formData: {},

                states: {
                    submitting: false,
                    errors:     [],
                }
            }
        },

        methods: {
            submitForm() {
                this.states.errors = []
                this.states.submitting = true

                $.ajax({
                    type:  "POST",
                    url:   '/subscribe',
                    data:  this.formData,
                    success(data) {
                        $('#newsletter-modal').modal('hide')
                        $('#newsletter-subscription-successful-modal').modal('show')
                        // cookie expires 10 years from now
                        window.Cookie.create('yps_newsletter_subscribed', true, 157680000)
                    },
                    error: (data) => {
                        let message;
                        if (message = get(data, 'responseJSON.message')) {
                            return this.states.errors.push(message)
                        }

                        this.states.errors.push("Something went wrong.")
                    },

                    complete: () => {
                        this.states.submitting = false
                    }
                })
            }
        }
    }
</script>
